/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AutomationTask/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Actions from './Actions/index'
import Assignee from './Assignee/index'
import Board from './Board/index'
import Description from './Description/index'
import Priority from './Priority/index'
import React from 'react'
import Stage from './Stage/index'
import Tags from './Tags/index'
import Title from './Title/index'
import TysiaIconLocationOn from 'DesignSystem/Svgs/TysiaIconLocationOn/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function AutomationTask({
  children,
  viewPath = "/DesignSystem/AutomationTask"
  
}) {
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtSpaceXl = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xl'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="AutomationTask.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-CVH6E': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginBottom={dtSpaceS}
 color={dtColorsNeutral500}
 text="Task Configuration"
 weight="medium"
/>
<Title
  viewPath={`${viewPath}/Title`}
/>
<Description
  viewPath={`${viewPath}/Description`}
/>
<Actions
  viewPath={`${viewPath}/Actions`}
/>
</div>
<div
  data-testid="AutomationTask.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 weight="medium"
 textTransform="uppercase"
 marginBottom={dtSpaceLs}
 marginTop={dtSpaceL}
 text="Add task to"
/>
<div
  data-testid="AutomationTask.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="AutomationTask.Vertical:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical2}`}
>
<div
  data-testid="AutomationTask.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<Board
  viewPath={`${viewPath}/Board`}
/>
<Stage
  viewPath={`${viewPath}/Stage`}
/>
</div>
</div>
</div>
<div
  data-testid="AutomationTask.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<div
  data-testid="AutomationTask.Vertical:3"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 weight="medium"
 textTransform="uppercase"
 marginTop={dtSpaceL}
 marginBottom={dtSpaceLs}
 text="Other details"
/>
<div
  data-testid="AutomationTask.Horizontal:3"
  data-view-path={viewPath}
 style={{'--g-2-CVH6E': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl,'--mb-3-CVH6E': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Horizontal3}`}
>
<Assignee
  viewPath={`${viewPath}/Assignee`}
/>
<Priority
  viewPath={`${viewPath}/Priority`}
/>
</div>
</div>
</div>
<div
  data-testid="AutomationTask.Horizontal:4"
  data-view-path={viewPath}
 style={{'--mb-3-CVH6E': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Horizontal4}`}
>
<TysiaIconLocationOn
  viewPath={`${viewPath}/TysiaIconLocationOn`}
 fill2={dtColorsNeutral400}
 height={20}
 width={20}
 marginLeft={-1}
 marginRight={3}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 marginTop={4}
 marginRight={dtSpaceXxs}
 text="Tags"
/>
<Tags
  viewPath={`${viewPath}/Tags`}
/>
</div>
</div>
{children}
</React.Fragment>)
}